module.exports = require("@ember/object/internals");